/* Tan Tesbih — optional gift plaque: 200 TRY charged at checkout, revision 2026-10-31 */
(()=> {
 'use strict';
 const SERVICE_ID=50005322301595;
 const get=(s,root=document)=>root.querySelector(s);
 const productPath=()=>location.pathname.startsWith('/products/');
 let processing=false;
 let activeForm=null;
 const money='200 TL';

 function setup(){
  if(!productPath())return;
  const detail=get('#MainContent .product-details');
  const form=get('form[action="/cart/add"]',detail||document)||get('#MainContent form[action="/cart/add"]');
  if(!form)return;
  const buttons=get('.product-form-buttons',form);
  if(!buttons)return;
  let panel=get('.tan-paid-plaque-panel',form);
  const legacy=get('.tan-gift-panel:not(.tan-paid-plaque-panel)',form);
  if(legacy)legacy.remove();
  if(!panel){
   panel=document.createElement('section');
   panel.className='tan-gift-panel tan-paid-plaque-panel';
   panel.setAttribute('aria-label','Hediye plaketi kişiselleştirme');
   panel.innerHTML=[
    '<h3>Hediye plaketi ister misiniz?</h3>',
    '<p>Tesbihiniz için isim ve soyadı yazılı hediye plaketi ekleyebilirsiniz. İsteğe bağlıdır.</p>',
    '<div class="tan-plaque-options" role="radiogroup" aria-label="Hediye plaketi tercihi">',
     '<label class="tan-plaque-option"><input type="radio" name="tan_plaque_choice" value="no" checked><span>Plaket istemiyorum</span></label>',
     '<label class="tan-plaque-option"><input type="radio" name="tan_plaque_choice" value="yes"><span>İsimli plaket ekle <strong>(+200 TL)</strong></span></label>',
    '</div>',
    '<div class="tan-plaque-name-area" hidden>',
     '<label for="tan-plaque-name">Plakete yazılacak isim ve soyadı</label>',
     '<input id="tan-plaque-name" type="text" autocomplete="off" maxlength="75" placeholder="İsim Soyisim" disabled>',
     '<p class="tan-plaque-help">200 TL ek hizmet bedeli sepette ayrı bir satır olarak görünür.</p>',
    '</div>',
    '<p class="tan-plaque-error" role="alert" aria-live="polite" hidden></p>'
   ].join('');
   const update=()=>{
    const yes=get('input[value="yes"]',panel)?.checked;
    const nameArea=get('.tan-plaque-name-area',panel);
    const name=get('#tan-plaque-name',panel);
    nameArea.hidden=!yes;
    name.disabled=!yes;
    name.required=Boolean(yes);
    get('.tan-plaque-error',panel).hidden=true;
   };
   panel.querySelectorAll('input[type=radio]').forEach(x=>x.addEventListener('change',update));
   update();
  }
  if(panel.nextElementSibling!==buttons)form.insertBefore(panel,buttons);
  activeForm=form;
  const wa=get('.tan-whatsapp-inquiry',form);
  const buy=get('.shopify-payment-button__button--unbranded',form);
  if(wa){
   const fs=buy?getComputedStyle(buy):null;
   wa.style.setProperty('font-size',fs?.fontSize||'13px','important');
   wa.style.setProperty('font-weight',fs?.fontWeight||'700','important');
   if(fs?.fontFamily)wa.style.setProperty('font-family',fs.fontFamily,'important');
  }
 }
 function showError(msg){
  const panel=get('.tan-paid-plaque-panel',activeForm||document);
  const el=get('.tan-plaque-error',panel||document);
  if(el){el.textContent=msg;el.hidden=false;}
 }
 function plaqueRequested(form){
  return get('.tan-paid-plaque-panel input[value="yes"]',form)?.checked===true;
 }
 function setWorking(form,working){
  const panel=get('.tan-paid-plaque-panel',form);
  if(!panel)return;
  panel.classList.toggle('tan-plaque-loading',working);
  panel.querySelectorAll('input').forEach(x=>{if(x.type==='radio')x.disabled=working;});
 }
 async function addWithPlaque(form,goCheckout){
  if(processing)return;
  const name=(get('#tan-plaque-name',form)?.value||'').trim().replace(/\s+/g,' ');
  const inp=get('#tan-plaque-name',form);
  if(name.length<2){
   showError('Plakete yazılacak isim ve soyadını girin.');
   inp?.focus();return;
  }
  const variant=Number(get('input[name="id"]',form)?.value);
  if(!Number.isInteger(variant)||variant<=0){showError('Ürün seçimi bulunamadı. Sayfayı yenileyip tekrar deneyin.');return;}
  const qtyField=get('.product-details input[name="quantity"]')||get('input[name="quantity"]',form);
  const qty=Math.max(1,Math.min(50,parseInt(qtyField?.value||'1',10)||1));
  const title=get('#MainContent h1')?.textContent.trim()||document.title.split('–')[0].trim();
  processing=true;setWorking(form,true);
  const root=window.Shopify?.routes?.root||'/';
  try{
   const payload={items:[
    {id:variant,quantity:qty,properties:{'Hediye plaketi':'İsimli hediye plaketi (+200 TL)','Plaket isim soyadı':name}},
    {id:SERVICE_ID,quantity:qty,properties:{'Plaket isim soyadı':name,'Tesbih':title,'_Ana ürün varyantı':String(variant)}}
   ]};
   const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
   if(!response.ok){
    const e=await response.json().catch(()=>({}));
    throw new Error((e.description||e.message||'Sepete eklenemedi.'));
   }
   const cartResult=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
   if(!cartResult.ok)throw new Error('Sepet kontrolü başarısız. Lütfen sepetinizi inceleyin.');
   const cart=await cartResult.json();
   const service=cart.items.find(x=>Number(x.variant_id)===SERVICE_ID&&x.properties?.['Plaket isim soyadı']===name);
   if(!service||Number(service.original_price)!==20000){
    throw new Error('200 TL plaket ücreti doğrulanamadı. Lütfen sepetinizi kontrol edin.');
   }
   window.location.assign(root+(goCheckout?'checkout':'cart'));
  }catch(error){
   showError(error?.message||'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
   processing=false;setWorking(form,false);
  }
 }
 function intercept(e,form,isBuy){
  if(!form||!plaqueRequested(form))return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation?.();
  if(processing)return;
  activeForm=form;
  addWithPlaque(form,isBuy);
 }
 document.addEventListener('click',e=>{
  if(!productPath())return;
  const target=e.target;
  if(!(target instanceof Element))return;
  const add=target.closest('button[name="add"],.add-to-cart-button');
  const buy=target.closest('shopify-buy-it-now-button button,.shopify-payment-button__button');
  const trigger=add||buy;
  if(!trigger)return;
  const form=trigger.closest('form[action="/cart/add"]')||get('#MainContent form[action="/cart/add"]');
  if(form)intercept(e,form,Boolean(buy));
 },true);
 document.addEventListener('submit',e=>{
  if(!productPath())return;
  const form=e.target;
  if(!(form instanceof HTMLFormElement)||form.action.indexOf('/cart/add')===-1)return;
  intercept(e,form,false);
 },true);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);
 else setup();
 setTimeout(setup,350);
 setTimeout(setup,1200);
 document.addEventListener('shopify:section:load',setup);
})();